import React, { useState } from "react";
import PropTypes from "prop-types";
import { Button, Pagination } from "antd";
import { VehicleRequisitionList } from "./VehicleRequisitionList";
import { VehicleAssignmentModal } from "./VehicleAssignmentModal";
import "../../../App.css";
import {
  Status,
  StatusByHexColor,
  isStatusSubmitted,
  isStatusApproved,
} from "../../model/common/Status";
import { useTranslation } from "react-i18next";

export default function VehicleRequisitionAssignmentForm({
  isLoading,
  data,
  allVehicles,
  onAdd,
  onView,
  onAssigned,
  getAvailableVehicles,
  onAttachmentClicked,
  setCurrentYear,
  pagination,
  setPagination,
  resetPagination,
}) {
  const { t } = useTranslation();
  const [showAssignmentForm, setShowAssignmentForm] = useState(false);
  const [tempItem, setTempItem] = useState();

  function submitVehicleAssignment(vehicleKey) {
    setShowAssignmentForm(false);
    let vehicleRequisition = { ...tempItem, VehicleKey: vehicleKey };
    onAssigned(vehicleRequisition);
  }

  function assignVehicle(selectedVehicleRequisition) {
    setTempItem(selectedVehicleRequisition);
    getAvailableVehicles(selectedVehicleRequisition.VehicleRequisitionKey, () =>
      setShowAssignmentForm(true)
    );
  }

  function getListActions(item) {
    return [
      <div key>
        <span
          style={{
            float: "left",
            fontStyle: "italic",
            marginLeft: "50px",
            color: StatusByHexColor[item.Status],
          }}
        >
          {Status[item.Status]}
        </span>

        <Button
          type="primary"
          size="default"
          style={{
            display:
              (!item.IsRequireApproval && isStatusSubmitted(item.Status)) ||
              isStatusApproved(item.Status)
                ? ""
                : "none",
          }}
          onClick={() => assignVehicle(item)}
        >
          {t("vehicleRequisitionForm.assign_vehicle")}
        </Button>
      </div>,
    ];
  }

  const footerElement = (footerValue, totalPagination) => (
    <div style={{ textAlign: "right", marginRight: "10px" }}>
      <Pagination
        style={{ display: "inline-flex", paddingRight: 10 }}
        defaultCurrent={pagination.current}
        current={pagination.current}
        total={totalPagination}
        onChange={onChangePagination}
        showTotal={(total) =>
          t("general.total") + ` ${total} ` + t("general.records")
        }
        defaultPageSize={pagination.pageSize}
        pageSize={pagination.pageSize}
      />
      {t("vehicleRequisitionForm.total_pending_assignment")} :{" "}
      <b style={{ color: "#0070cc" }}>
        {data.filter((x) => !x.IsViewOnly).length}
      </b>
    </div>
  );

  function onChangePagination(page, pageSize) {
    setPagination({
      current: page,
      minIndex: (page - 1) * pageSize,
      maxIndex: page * pageSize,
      pageSize: pageSize,
    });
  }

  return (
    <div>
      <VehicleRequisitionList
        isLoading={isLoading}
        data={data}
        onAdd={onAdd}
        onItemViewed={onView}
        isSelectable={true}
        isMultipleAction={false}
        onListActionsRendered={getListActions}
        filterCheckedText={"Show unassigned vehicle requisition(s) only"}
        footerElement={footerElement}
        onAttachmentClicked={onAttachmentClicked}
        setCurrentYear={setCurrentYear}
        pagination={pagination}
        resetPagination={resetPagination}
      />

      <VehicleAssignmentModal
        isVisible={showAssignmentForm}
        allVehicles={allVehicles}
        selectedVehicle={tempItem}
        onSaved={submitVehicleAssignment}
        onCancelled={() => setShowAssignmentForm(false)}
      />
    </div>
  );
}

VehicleRequisitionAssignmentForm.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  data: PropTypes.array.isRequired,
  allVehicles: PropTypes.array.isRequired,
  onAdd: PropTypes.func.isRequired,
  onView: PropTypes.func.isRequired,
  onAssigned: PropTypes.func.isRequired,
  getAvailableVehicles: PropTypes.func.isRequired,
  onAttachmentClicked: PropTypes.func.isRequired,
  setCurrentYear: PropTypes.func.isRequired,
  pagination: PropTypes.object.isRequired,
  setPagination: PropTypes.func.isRequired,
  resetPagination: PropTypes.func.isRequired,
};
